module.exports = __webpack_public_path__ + "img/female_in_bath.ba824d93.jpg";